import React, { useState, useEffect } from 'react';
import { api } from '../App';

function Helpers() {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPending = async () => {
    setLoading(true);
    try {
      const data = await api('/admin/helpers/pending');
      setPending(data.helpers);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadPending(); }, []);

  const verifyHelper = async (id, status) => {
    const action = status === 'approved' ? 'approve' : 'reject';
    if (!window.confirm(`Are you sure you want to ${action} this helper?`)) return;
    try {
      await api(`/admin/helpers/${id}/verify`, {
        method: 'PATCH',
        body: JSON.stringify({ status }),
      });
      loadPending();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 style={{ marginBottom: 20 }}>Helper Verification</h1>
      
      <div className="card">
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>
        ) : pending.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✓</div>
            <p>No pending helper verifications</p>
          </div>
        ) : (
          <div>
            <p style={{ marginBottom: 20, color: '#666' }}>
              {pending.length} helper{pending.length !== 1 ? 's' : ''} awaiting verification
            </p>
            
            {pending.map(helper => (
              <div key={helper.id} style={{
                border: '1px solid #eee',
                borderRadius: 12,
                padding: 20,
                marginBottom: 16,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', gap: 16 }}>
                    <div style={{
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      background: '#ddd',
                      backgroundImage: helper.profile_photo_url ? `url(${helper.profile_photo_url})` : 'none',
                      backgroundSize: 'cover',
                    }} />
                    <div>
                      <h3 style={{ marginBottom: 4 }}>{helper.first_name} {helper.last_name}</h3>
                      <p style={{ color: '#666', fontSize: 14 }}>{helper.email}</p>
                      <p style={{ color: '#888', fontSize: 13, marginTop: 8 }}>
                        Applied: {new Date(helper.created_at).toLocaleDateString()}
                      </p>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button className="btn btn-success" onClick={() => verifyHelper(helper.id, 'approved')}>
                      Approve
                    </button>
                    <button className="btn btn-danger" onClick={() => verifyHelper(helper.id, 'rejected')}>
                      Reject
                    </button>
                  </div>
                </div>

                {helper.bio && (
                  <div style={{ marginTop: 16, padding: 12, background: '#f8f9fa', borderRadius: 8 }}>
                    <strong style={{ fontSize: 13 }}>Bio:</strong>
                    <p style={{ fontSize: 14, marginTop: 4 }}>{helper.bio}</p>
                  </div>
                )}

                {helper.documents && helper.documents.length > 0 && (
                  <div style={{ marginTop: 16 }}>
                    <strong style={{ fontSize: 13 }}>Documents ({helper.documents.length}):</strong>
                    <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                      {helper.documents.map(doc => (
                        <a key={doc.id} href={doc.url} target="_blank" rel="noopener noreferrer" style={{
                          padding: '6px 12px',
                          background: '#e3f2fd',
                          borderRadius: 6,
                          fontSize: 13,
                          color: '#1565c0',
                        }}>
                          {doc.type || 'Document'}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Helpers;
